import { render } from "./IntroTextImg.vue?vue&type=template&id=6c3b117f&scoped=true"
import script from "./IntroTextImg.vue?vue&type=script&lang=js"
export * from "./IntroTextImg.vue?vue&type=script&lang=js"

import "./IntroTextImg.vue?vue&type=style&index=0&id=6c3b117f&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3b117f"]])

export default __exports__